import { Component, OnInit } from '@angular/core';
import { UmsService } from '../ums.service';


interface FoodNode {
  name: string;
  icon: string;
  children?: FoodNode[];
}

const TREE_DATA: FoodNode[] = [
  {
  name: 'Contact Us',
  icon: 'dashboard'
  },
  {
    name: 'Academics',
    icon: 'dashboard',
    children: [
      {
        name: 'My Curriculum ',
        icon: '',
        children: [
          {name: 'Programme Core',
          icon: '', },
         {name: 'Programme Elective',
        icon: '', },
        {name: 'University Core',
        icon: '', },
        {name: 'University Elective',
        icon: '', },
        {name: 'Specialization Elective',
        icon: '', },
        {name: 'Non Credit Course',
        icon: '', }],



      },
      {
        name: 'Menu 2',

        icon: '',
        children: [
          {name: 'Submenu 1',
          icon: '', },
         {name: 'Submenu 2',
        icon: '', }],
      },
    ],
  },
];
@Component({
  selector: 'app-parents-form',
  templateUrl: './parents-form.component.html',
  styleUrls: ['./parents-form.component.scss']
})
export class ParentsFormComponent implements OnInit {
  listParentMenu: any;
  dataSource: any;

  constructor(  public umsService: UmsService, ) { }

  ngOnInit(): void {
    // this.menurole = localStorage.getItem('user');
    //  (this.menurole === 'parent'){
    //   this.loadParentMenu();
    // }
  }

  hasChild = (_: number, node: FoodNode) => !!node.children && node.children.length > 0;
  loadParentMenu(){
    this.umsService.getParentsMenu().subscribe(res => {
      const TREE_DATA: FoodNode[]  = res.data;
      this.listParentMenu = res.data;
      this.dataSource.data = TREE_DATA;

    });
  }
}
